/** Reducer for List certificate request */

import { fromJS } from 'immutable';
import { SET_LIST_ACTIVITY } from '../actions/activityConst';

export const initialState = {
  listActivity: []
};

const initialImmutableState = fromJS(initialState);

const activity = (state = initialState, action = {}) => {
  switch (action.type) {
    case SET_LIST_ACTIVITY:
      state = initialState;
      return state.listActivity.concat(action.activity);
    default:
      return state;
  }
};

export default activity;
